import React, { useState, useEffect } from "react";
import { useRecoilState } from "recoil";

import { ECrossSitePromotionType } from "../../@types";
import { AllstarSiteData, PartnerViewSession } from "../../State";
import { PromoSession } from "../../State/promoSession";
import { FirstLandTakeover } from "./Components/FirstLandTakeover";
import { SideRailAd } from "./Components/SideRailAd";
import { CrossSitePromotionViewModel } from "./ViewModel";

type CrossSitePromotionProps = {
  type?: ECrossSitePromotionType;
  doneLoadingCallback?: (promotionsData: any) => boolean;
  loadDataOnly?: boolean;
};

export const CrossSitePromotion = ({
  type,
  loadDataOnly,
}: CrossSitePromotionProps) => {
  const [partnerViewSession, setPartnerViewSession] =
    useRecoilState(PartnerViewSession);
  const { promotionsData, promotionsLoading }: any =
    CrossSitePromotionViewModel();
  const [siteData, setSiteData] = useRecoilState(AllstarSiteData);
  const [loadedSiteData, setLoadedSiteData] = useState(false);
  const [promoSession, setPromoSession] = useRecoilState(PromoSession);

  useEffect(() => {
    if (promotionsData && loadDataOnly && !promotionsLoading) {
      setPromoSession({
        ...promoSession,
        ...promotionsData.promotions,
        loaded: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [promotionsLoading]);

  if (promotionsLoading) return <></>;

  switch (type) {
    case ECrossSitePromotionType.FirstLandTakeover: {
      const firstLandModal =
        promotionsData?.promotions?.activeSiteFirstLandModal;
      if (firstLandModal?.length)
        return <FirstLandTakeover overlaySlides={firstLandModal} />;
      else return <></>;
    }
    case ECrossSitePromotionType.SideRailAd: {
      const sideRailAd = promotionsData?.promotions?.activeSiteSideRailAd;
      if (sideRailAd) return <SideRailAd {...sideRailAd} />;
      else return <></>;
    }

    case ECrossSitePromotionType.VideoPlayerCTA: {
      const videoPlayerPromos =
        promotionsData?.promotions?.activeSiteVideoPlayerPromos;
      if (
        partnerViewSession?.overlayConfig?.display &&
        videoPlayerPromos?.length &&
        !partnerViewSession.promotion.display
      ) {
        setPartnerViewSession({
          ...partnerViewSession,
          promotion: {
            ...videoPlayerPromos[0],
            display: true,
          },
        });
      }
      return <></>; // we dont need to return content here, but we need the viewmodel to gather data and IF it is a partnerView session, set the data. For the overlay
    }
    case ECrossSitePromotionType.CarouselSlide: {
      const carouselPromos = promotionsData?.promotions?.activeCarouselPromos;
      if (carouselPromos?.length) {
        if (loadDataOnly && !loadedSiteData) {
          setLoadedSiteData(true);

          const promosToDisplay = [];

          for (const promotion of carouselPromos) {
            promosToDisplay.push({
              ...promotion,
              video: promotion.image,
              image: promotion.image,
              buttonCopy: promotion.buttonCopy,
            });
          }
          setSiteData({
            ...siteData,
            promotions: promosToDisplay,
          });
          return <></>;
        } else {
          return <></>;
        }
      } else {
        if (!loadedSiteData && !carouselPromos) {
          setLoadedSiteData(true);
          setSiteData({
            ...siteData,
            promotions: undefined,
          });
        }

        return <></>;
      }
    }

    default:
      return <></>;
  }
};
